<button [type]="type" class="btn btn-primary button" [class.showAsDisabled]="showAsDisabled" (click)="onClick()" [disabled]="disabled">
    {{ title }}
</button>
